import React from 'react'
import Style from './Team.module.css'
import team1 from '../img/ourteam1.jpg'
import team2 from '../img/ourteam2.png'
import team3 from '../img/ourteam4.jpg'
import Carousel from 'react-bootstrap/Carousel';

const Team = () => {
    return (
        <>
            <Carousel className={Style.slider}>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                      
                        src={ team1 }
                        alt="First slide"
                    />

                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                       
                        src={ team2 }
                        alt="Second slide"
                    />

                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                       
                        src={ team3 }
                        alt="Third slide"
                    />
                </Carousel.Item>
            </Carousel>

            <div className={ Style.bio }>
                <h6 className={ Style.about }>Our Team</h6>
                <br />
                <hr /><br />
                <p>👉Our team of 9 specialists forms an asset of the company, depending on whom we have been able to earn a reputation and goodwill in a short time frame. Our collection of imitation jari have been appreciated by clients located across the globe and this has been made possible only due to the unremitting efforts and hard work put in by our proficient and adept team of professionals.</p>
                <hr /><br />
                <p>👉Their hands on experience and in-depth knowledge have enabled us to design a gamut, keeping in mind the varied needs of sewing and embroidery. They are well equipped to understand the market requirements and therefore work in tandem with clients to comprehend their specific needs and accordingly develop the range. Their proficiency not only lies in delivering a qualitative range but also in meeting the consignments deadlines.</p>
                <hr /><br />
                <p>👉Further, every member right from the procuring agents, designers to craftsmen, technicians, skilled and unskilled labourers, quality auditors and sales and marketing, work in close cooperation to make sure that the organization is successful at winning the trust and loyalty of customers through quality products and ethical practices.</p>
                <hr /><br />
            </div>
        </>
    )
}

export default Team
